import { Folder } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const FolderIcon = DeckardIconWrapper({ Icon: Folder });
